import {
  actionTypes,
  fetchApprovalDetailFailure,
  fetchApprovalDetailSuccess,
  fetchApprovalSuccess,
  approveApprovalRequestFailure,
  approveApprovalRequestSuccess,
  rejectApprovalRequestFailure,
  rejectApprovalRequestSuccess,
  fetchApprovalFailure,
  deleteAttachmentApprovalsSuccess,
  deleteAttachmentApprovalsFailure,
  saveAttachmentsApprovalsSuccess,
  saveAttachmentsApprovalsFailure,
  fetchPaginationApprovalsSuccess,
  fetchPaginationApprovalsFailure,
  fetchCSVApprovalsSuccess,
  fetchCSVApprovalsFailure,
} from "./actions";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import {
  fetchApprovalRequests,
  fetchApprovalReject,
  fetchApprovalApprove,
  fetchApprovalDetail,
  fetchPaginatedApprovalsService,
} from "./services";
import {
  deleteAttachments,
  saveRequestAttachments,
} from "../../../common/ManualsUtils/ManualsServices";

const fetchPaginatedApprovalsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_PAGINATION_APPROVALS_REQUEST),
    mergeMap((action: any) =>
      fetchPaginatedApprovalsService(action.payload).pipe(
        map((response) => fetchPaginationApprovalsSuccess(response)),
        catchError((error: any) => of(fetchPaginationApprovalsFailure(error)))
      )
    )
  );

const fetchCSVApprovalsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_CSV_APPROVALS_REQUEST),
    mergeMap((action: any) =>
      fetchPaginatedApprovalsService(action.payload).pipe(
        map((response) => fetchCSVApprovalsSuccess(response)),
        catchError((error: any) => of(fetchCSVApprovalsFailure(error)))
      )
    )
  );

const fetchApprovalRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_APPROVALS_REQUEST),
    mergeMap(() =>
      fetchApprovalRequests().pipe(
        map((response) => fetchApprovalSuccess(response)),
        catchError((error: any) => of(fetchApprovalFailure(error)))
      )
    )
  );

const approveApprovalRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.APPROVE_APPROVAL_REQUEST),
    mergeMap((action: any) =>
      fetchApprovalApprove(action.payload).pipe(
        map((response) => approveApprovalRequestSuccess(response)),
        catchError((error: any) => of(approveApprovalRequestFailure(error)))
      )
    )
  );

const rejectApprovalRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.REJECT_APPROVALS_REQUEST),
    mergeMap((action: any) =>
      fetchApprovalReject(action.payload).pipe(
        map((response) => {
          return rejectApprovalRequestSuccess(response);
        }),
        catchError((error: any) => {
          return of(rejectApprovalRequestFailure(error));
        })
      )
    )
  );

const fetchApprovalDetailEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_APPROVAL_DETAIL),
    mergeMap((action: any) =>
      fetchApprovalDetail(action.id).pipe(
        map((response) => {
          return fetchApprovalDetailSuccess(response);
        }),
        catchError((error: any) => {
          return of(fetchApprovalDetailFailure(error));
        })
      )
    )
  );

export const fetchDeleteAttachment = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_ATTACHMENT_APPROVALS),
    mergeMap((action: any) =>
      deleteAttachments(action.id).pipe(
        map((response: any) => deleteAttachmentApprovalsSuccess(response)),
        catchError((error: any) => {
          return of(deleteAttachmentApprovalsFailure(error));
        })
      )
    )
  );

export const fetchSaveAttachments = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SAVE_ATTACHMENTS_APPROVALS),
    mergeMap((action: any) =>
      saveRequestAttachments(action.id, action.files).pipe(
        map((response: any) => saveAttachmentsApprovalsSuccess(response)),
        catchError((error: any) => {
          return of(saveAttachmentsApprovalsFailure(error));
        })
      )
    )
  );

export default [
  fetchCSVApprovalsEpic,
  fetchPaginatedApprovalsEpic,
  fetchApprovalRequestsEpic,
  approveApprovalRequestEpic,
  rejectApprovalRequestEpic,
  fetchApprovalDetailEpic,
  fetchDeleteAttachment,
  fetchSaveAttachments,
];
